import { useEffect } from 'react'

import { form } from '../formState'

export function useUpdateEmailRelatedFields() {
  const formApi = form.useFormApi()

  const emailField = form.useFormField('companyEmail')
  const emailFieldValue = emailField.field.value

  useEffect(() => {
    const empty = isEmailEmpty(emailFieldValue)
    formApi.setFieldDisabledState('showContactEmail', empty)
    formApi.setFieldDisabledState('useCompanyEmailAsReplyTo', empty)
  }, [emailFieldValue, formApi])
}

function isEmailEmpty(email: string) {
  return email.trim().length === 0
}
